import styled from "styled-components/macro";
import media from "../../constants/MediaQuery";

const AuEmage = () => {
  return (
    <AuEmageStyling>
      <div className="AuEmage__AuEmageStyling__au-container container">
        <div
          className="AuEmage__AuEmageStyling__au-container--dot-emage"
          style={{ backgroundImage: "url('/assets/images/dots.svg')" }}
        />
        <img
          className="AuEmage__AuEmageStyling__au-container--about emage"
          src="./assets/images/aboutUs.png"
          alt="dotted-emage"
        />
      </div>
    </AuEmageStyling>
  );
};
const AuEmageStyling = styled.div`
  position: absolute;
  right: 0;
  @media screen and (max-width: 768px) {
    position: relative;
  }
  .emage {
    width: 100%;
  }
  .AuEmage__AuEmageStyling {
    position: relative;
    &__au-container {
      position: relative;
      width: 100%;
      padding: 33px;
      &--dot-emage {
        max-width: 600px;
        width: 75%;
        height: 75%;
        max-height: 400px;
        position: absolute;
        left: 0;
        bottom: 0;
        ${media.tabletMin` `}
      }
      &--about {
        position: relative;
        z-index: 1;
        min-width: 200px;
        ${media.smallDesktopMin`min-width: 300px;`}
      }
    }
  }
`;
export default AuEmage;
